import _ from 'underscore';
import { useEffect, useState } from 'react';
import { getGoals } from './uet-goal-crud';

export const useGoalwithParams = ({
  serverContext,
  activity,
  params,
}) => {
  const [goals, setGoals] = useState([]);
  const [count, setCount] = useState(0);
  const { Token } = serverContext;
  const { Id: aid, AdvertiserCustomerID: cid } = serverContext.CurrentAccount;

  useEffect(() => {
    getGoals(cid, aid, params).then((result) => {
      activity.trace('Load Goals Successed');
      const finalResult = _.get(result, 'value', []);
      if (params && params.$count) {
        setCount(_.get(result, '@odata.count', 0));
      }
      setGoals(finalResult);
    }).catch((error) => {
      activity.error(`Load Goals Failed: ${JSON.stringify(error)}`);
    });
  }, [Token, activity, aid, cid, params]);

  return [goals, count];
};
